import React from 'react';
import Topbar from '../../Topbar';
import { useTheme } from '../../ThemeContext';
import { useOutletContext } from 'react-router-dom';

export default function Achievements() {
  const { C } = useTheme();
  const { onMenuClick } = useOutletContext();
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: C.bgDeep }}>
      <Topbar title="Achievements" onMenuClick={onMenuClick}/>
      <div style={{ padding: "60px 28px", textAlign: "center" }}>
        <div style={{ fontSize: 14, color: C.textSecond, fontFamily: "'Space Mono', monospace" }}>Achievements</div>
        <div style={{ fontSize: 13, color: C.textMuted, marginTop: 8 }}>Page coming soon</div>
      </div>
    </div>
  );
}
